import { useClientPortalConfigContext } from "../context";

interface IUseBookingAccessHook {
    canBookAppointments: boolean;
    canBookClasses: boolean;
}

export const useBookingAccess = (): IUseBookingAccessHook => {
    const { clientPortalConfig } = useClientPortalConfigContext();

    const isLoggedInUserAllowedToBookAppointment =
        clientPortalConfig?.userDetails?.isLoggedInUserAllowedToBookAppointment ?? true;

    return {
        canBookAppointments:
            (clientPortalConfig?.featureAccess?.canBookAppointments ?? false) && isLoggedInUserAllowedToBookAppointment,
        canBookClasses:
            (clientPortalConfig?.featureAccess?.canBookClasses ?? false) && isLoggedInUserAllowedToBookAppointment,
    };
};
